export	function pagePopup() {
		const popup = document.querySelector('.farlo-ui-popup');
		const popupInner = document.querySelector('.farlo-ui-popup__inner');
		const closeButton = document.querySelector('.farlo-ui-popup__button');
		const popupCookieName = 'frontpagePopupSeen';

		function showPopup() {
			popup.style.display = 'flex';
		}

		function hidePopup() {
			popup.style.display = 'none';
			setCookie(popupCookieName, 'true', 30)
		}

		function setCookie(name, value, days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			const expires = 'expires=' + date.toUTCString();
			document.cookie = name + '=' + value + ';' + expires + ';path=/';
		}

		function getCookie(name) {
			const nameEQ = name + '=';
			const ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) === ' ') {
					c = c.substring(1, c.length);
				}
				if (c.indexOf(nameEQ) === 0) {
					return c.substring(nameEQ.length, c.length);
				}
			}
			return null;
		}

		closeButton.addEventListener('click', function () {
			hidePopup();
		});

		popup.addEventListener('click', function (event) {
			if (!popupInner.contains(event.target)) {
				hidePopup();
			}
		});

		if (!getCookie(popupCookieName)) {
			showPopup();
		}
	}